
import { Component, Prop, Vue } from 'bits/vue'
import OzBaseButton, { OzBaseButtonHrefMode } from 'library/v4/components/OzBaseButton.vue'

export enum OzListRowSeparator {
  None = 'none',
  Short = 'short',
  Long = 'long',
  FullWidth = 'full-width',
}

@Component({ components: { OzBaseButton } })
export default class OzListRow extends Vue {
  Separator = OzListRowSeparator

  /**
   * Separator type
   */
  @Prop({ default: OzListRowSeparator.Short }) separator!: OzListRowSeparator

  /**
   * Dark mode
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Set to false if list is for display only.
   */
  @Prop({ default: true }) clickable!: boolean

  /**
   * URL is handled based on hrefMode
   */
  @Prop({ default: undefined }) href?: string

  /**
   * - `Default` - triggers a page reload
   * - `DisplayOnly` - `href` is for show only. Handle it using `@click`
   * - `HistoryPushState` - Changes current URL. Handle it using `@click`.
   */
  @Prop({ default: OzBaseButtonHrefMode.Default }) hrefMode?: OzBaseButtonHrefMode

  get xSeparator(): boolean {
    return this.separator !== 'none'
  }

  get lineSeparatorClass(): Record<string, boolean> {
    const colorClasses = {
      'after:bg-divider-gray dark:after:bg-divider-gray-dark': this.darkMode === 'auto',
      'after:bg-divider-gray': this.darkMode === false,
      'after:bg-divider-gray-dark': this.darkMode === true,
    }
    return {
      'after:absolute': true,
      'after:h-px': true,
      'after:bottom-[-4px]': true,
      ...colorClasses,
    }
  }
}

export { OzBaseButtonHrefMode as OzListRowHrefMode }
